import { createSelector } from 'reselect';
import { assign } from 'lodash';

const selectEstimate = state => state.screens.EstimateView.estimate;
const selectEditable = state => state.screens.EstimateView.editable;

export default createSelector(
  [selectEstimate, selectEditable],
  (estimate, editable) => {

    if (!estimate) return [];

    let incrementer = 0;

    const items = [];

    if (estimate.estimate_caveats.length > 0) {

      items.push({
        type: 'Header',
        height: 60
      });

      estimate.estimate_caveats.forEach((estimateCaveat, estimateCaveatIndex) => {

        incrementer += 1;
        const  lineNumber = incrementer;

        items.push({
          type: 'Item',
          height: 50,
          estimateCaveat: assign({}, estimateCaveat, { line_number: lineNumber }),
          estimateCaveatIndex
        });

      })

      items.push({
        type: 'Footer',
        height: editable ? 160 : 60
      });

    }

    if (estimate.estimate_caveats.length === 0) {

      items.push({
        type: 'Placeholder',
        height: 100
      });

    }

    return items;

  }
)
